import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LinkButton from 'SF/LinkButton';
import css from './PhotoUploadLink.scss';
import Icon from 'SF/MaterialIcon';
import PhotoUpload from './PhotoUpload';
import { getPhotoURL } from 'utils/images';

/**
 * @returns {node} the component that links to and controls a photo upload
 */
const PhotoUploadLink = ({ allowPhotoUpload, isIE, photoAcceptTypes, photoElementId, uuid, validatePhoto }) => {
    const [uploadOpen, setUploadOpen] = useState(false);

    /**
     * refreshes the photo showing on the profile
     */
    const photoUploaded = () => {
        document.getElementById(photoElementId).style.cssText = `background-image: url(${getPhotoURL(uuid, true)})`;
    };
    
    if (!allowPhotoUpload) return null;
    return (
        <>
            <LinkButton className={css['upload']} onClick={() => { setUploadOpen(true) }}>
                <Icon icon="camera_alt" aria-hidden={true} className={css['upload-photo-icon']} />Upload Photo
            </LinkButton>
            <PhotoUpload isIE={isIE}
                         isOpen={uploadOpen}
                         onClose={() => setUploadOpen(false)}
                         onUpload={photoUploaded}
                         photoAcceptTypes={photoAcceptTypes}
                         validatePhoto={validatePhoto} />
        </>
    );
};

PhotoUploadLink.defaultProps = {
    allowPhotoUpload: false
};

PhotoUploadLink.propTypes = {
    allowPhotoUpload: PropTypes.bool,
    isIE: PropTypes.bool,
    photoAcceptTypes: PropTypes.string,
    photoElementId: PropTypes.string,
    uuid: PropTypes.string,
    validatePhoto: PropTypes.func.isRequired
};

export default PhotoUploadLink;
